import React from "react";
import DraggableFloater from "./DraggableFloater";

/**
 * CoachOrbButton — a glowing violet orb on the main screen that opens
 * the Mind Coach page. Companion to TradingOrbButton (which opens the
 * trading page). Owner brief Feb 2026: "I need this building in to my
 * app" — 7 cognitive coach personas. This is the shortcut in.
 */
export default function CoachOrbButton() {
  return (
    <DraggableFloater
      storageKey="rawco-coach-orb-pos"
      initial={{ right: 24, bottom: 290 }}
      zIndex={45}
      testid="coach-orb-floater"
    >
      <button
        type="button"
        onClick={() => { window.location.href = "/coach"; }}
        aria-label="Open Mind Coach"
        className="rawco-coach-orb"
        data-testid="coach-orb-btn"
      >
        <svg viewBox="0 0 100 100" width="100%" height="100%" className="rawco-coach-orb-svg">
          <defs>
            <radialGradient id="rawco-coach-grad" cx="35%" cy="30%" r="70%">
              <stop offset="0%"   stopColor="#f0abfc"/>
              <stop offset="45%"  stopColor="#a855f7"/>
              <stop offset="100%" stopColor="#312e81"/>
            </radialGradient>
            <radialGradient id="rawco-coach-core" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgba(255,255,255,0.85)"/>
              <stop offset="60%" stopColor="rgba(240,171,252,0.0)"/>
            </radialGradient>
          </defs>

          {/* outer glow rings */}
          <circle cx="50" cy="50" r="46" fill="none"
                  stroke="rgba(217,70,239,0.35)" strokeWidth="0.8"
                  className="rawco-coach-orb-ring rawco-coach-orb-ring-1"/>
          <circle cx="50" cy="50" r="42" fill="none"
                  stroke="rgba(217,70,239,0.5)"  strokeWidth="0.6"
                  className="rawco-coach-orb-ring rawco-coach-orb-ring-2"/>

          {/* main orb */}
          <circle cx="50" cy="50" r="36" fill="url(#rawco-coach-grad)"/>
          <circle cx="50" cy="50" r="36" fill="url(#rawco-coach-core)"/>

          {/* Brain/mind glyph — three connected neuron nodes */}
          <g style={{ filter: "drop-shadow(0 0 2px #fff)" }}>
            <line x1="34" y1="42" x2="50" y2="34" stroke="#f0abfc" strokeWidth="1.5"/>
            <line x1="50" y1="34" x2="66" y2="46" stroke="#f0abfc" strokeWidth="1.5"/>
            <line x1="34" y1="42" x2="42" y2="60" stroke="#f0abfc" strokeWidth="1.5"/>
            <line x1="66" y1="46" x2="58" y2="62" stroke="#f0abfc" strokeWidth="1.5"/>
            <line x1="42" y1="60" x2="58" y2="62" stroke="#f0abfc" strokeWidth="1.5"/>
            <circle cx="34" cy="42" r="3" fill="#fff"/>
            <circle cx="50" cy="34" r="3.5" fill="#fff"/>
            <circle cx="66" cy="46" r="3" fill="#fff"/>
            <circle cx="42" cy="60" r="2.5" fill="#fff"/>
            <circle cx="58" cy="62" r="2.5" fill="#fff"/>
          </g>

          {/* subtle pulse blob */}
          <circle cx="38" cy="38" r="6" fill="rgba(255,255,255,0.55)" className="rawco-coach-orb-spec"/>
        </svg>
        <div className="rawco-coach-orb-label">MIND</div>
      </button>

      <style>{`
        .rawco-coach-orb {
          position: relative;
          width: 64px; height: 64px;
          background: transparent;
          border: none;
          padding: 0;
          cursor: pointer;
          filter: drop-shadow(0 0 14px rgba(217,70,239,0.55))
                  drop-shadow(0 0 28px rgba(168,85,247,0.35));
          transition: filter 200ms ease, transform 200ms ease;
        }
        .rawco-coach-orb:hover {
          filter: drop-shadow(0 0 22px rgba(217,70,239,0.85))
                  drop-shadow(0 0 40px rgba(168,85,247,0.55));
          transform: scale(1.06);
        }
        .rawco-coach-orb:active { transform: scale(0.96); }
        .rawco-coach-orb-svg { display: block; }
        .rawco-coach-orb-ring-1 {
          animation: rawco-coach-spin 14s linear infinite;
          transform-origin: 50% 50%;
          stroke-dasharray: 6 10;
        }
        .rawco-coach-orb-ring-2 {
          animation: rawco-coach-spin-rev 18s linear infinite;
          transform-origin: 50% 50%;
          stroke-dasharray: 3 12;
        }
        .rawco-coach-orb-spec {
          animation: rawco-coach-pulse 2.4s ease-in-out infinite;
        }
        .rawco-coach-orb-label {
          position: absolute;
          left: 50%; bottom: -14px;
          transform: translateX(-50%);
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.15em;
          color: #f0abfc;
          text-shadow: 0 0 6px rgba(217,70,239,0.6);
          pointer-events: none;
          user-select: none;
        }
        @keyframes rawco-coach-spin     { from { transform: rotate(0); } to { transform: rotate(360deg); } }
        @keyframes rawco-coach-spin-rev { from { transform: rotate(360deg); } to { transform: rotate(0); } }
        @keyframes rawco-coach-pulse {
          0%,100% { opacity: 0.55; transform: scale(1); }
          50%     { opacity: 0.9;  transform: scale(1.18); }
        }
      `}</style>
    </DraggableFloater>
  );
}
